/**
 * Insurance Leads Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncManageLeadsComponent,
  AsyncAddLeadComponent,
  AsyncModifyLeadComponent,
  AsyncSetPricesComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageLeadsComponent}
      />
      <Route path={`${match.url}/create`} component={AsyncAddLeadComponent} />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyLeadComponent}
      />
      <Route
        path={`${match.url}/set-prices`}
        component={AsyncSetPricesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
